import Update, { IUpdateRawQueryList } from '@models/Update.model';
import { INewUpdates } from '@store/redux/features/updatesOptimistic/updatesOptimisticSlice';
/**
 * Get an updatedUpdate
 */
export function getUpdate(
  update: IUpdateRawQueryList,
  backupUpdatedUpdates: INewUpdates[] | undefined,
) {
  // 1. Update exitss
  const backup = backupUpdatedUpdates?.find(item2 => {
    return item2.update.id === update.id;
  });

  if (backup) {
    // invalidation handled automatically.
    return Update.fromRawQueryListApiModel(backup.update);
  }

  return update;
}
